import React, { ReactNode } from 'react';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';

export interface ReportingCardProps {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
  noPadding?: boolean;
  actions?: ReactNode;
}

export const ReportingCard: React.FC<ReportingCardProps> = ({
  title,
  subtitle,
  children,
  noPadding = false,
  actions,
}) => {
  const hasHeader = !!title || !!subtitle || !!actions;

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {hasHeader && (
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: 2.5,
              py: 2,
              gap: 2,
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              {title && (
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: '0.06em',
                    color: 'text.primary',
                    fontSize: '0.8rem',
                  }}
                >
                  {title}
                </Typography>
              )}
              {subtitle && (
                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.25 }}>
                  {subtitle}
                </Typography>
              )}
            </Box>
            {actions && <Box sx={{ flexShrink: 0 }}>{actions}</Box>}
          </Box>
          <Divider />
        </>
      )}
      <CardContent
        sx={{
          p: noPadding ? 0 : 2.5,
          flex: 1,
          '&:last-child': { pb: noPadding ? 0 : 2.5 },
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
};
